



















import Vue from 'vue'
import { mapState } from 'vuex'
import Message from '../Message/Message.vue'
export default Vue.extend({
  components: {
    appMessage: Message,
  },
  props: {
    messages: Array,
  },
  computed: {
    ...mapState(['profile']),
  },
})
